module.exports = __webpack_public_path__ + "assets/img/banner2.ca5788b7.png";